export const upsertUserFavorites = ({ favorites = [], currentFavoriteId }) => {
  // Create a shallow copy to avoid mutating the original array
  let updatedFavorites = [...favorites];

  // Normalize favorites: ensure all items are objects with ids
  updatedFavorites = updatedFavorites.map(item =>
    typeof item === 'string'
      ? {
          coverImage: '',
          ids: [item],
          name: `Category_${item.slice(0, 8)}`,
        }
      : item
  );

  // Check if the currentFavoriteId already exists in any category
  const categoryIndex = updatedFavorites.findIndex(cat => cat.ids?.includes(currentFavoriteId));

  if (categoryIndex !== -1) {
    // ID already exists — return as is (no duplication)
    return updatedFavorites;
  }

  // Find a category to append this ID to (use the first available category if any)
  const firstCategory = updatedFavorites.find(cat => Array.isArray(cat.ids));

  if (firstCategory) {
    firstCategory.ids = [...new Set([...firstCategory.ids, currentFavoriteId])];
  } else {
    // No categories exist yet — create a new one
    updatedFavorites.push({
      coverImage: '',
      ids: [currentFavoriteId],
      name: `New_Category_${Date.now()}`, // unique default name
    });
  }

  return updatedFavorites;
};

export const upsertListingLikes = ({ likes = [], userId }) => {
  if (!likes.includes(userId)) {
    likes.push(userId);
  }
  return likes;
};
